import { render, staticRenderFns } from "./OneCartModalAdd.vue?vue&type=template&id=23232430&scoped=true&"
import script from "./OneCartModalAdd.vue?vue&type=script&lang=ts&"
export * from "./OneCartModalAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_css-loader@4.3.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23232430",
  null
  
)

export default component.exports